import { Button, Result, Typography } from 'antd';
import React from 'react';

const { Paragraph, Text } = Typography;

/**
 * Render-ийн үед гарсан алдааг барьж, ойлгомжтой хуудас харуулна.
 *
 * Үүнгүйгээр компонентын нэг алдаа бүх модыг унагаж, хэрэглэгчид ЦАГААН хуудас
 * үлддэг — юу болсныг ч, дараа нь юу хийхээ ч мэдэхгүй, зөвхөн browser-ийн
 * console-д л ул мөр үлдэнэ.
 *
 * `componentDidCatch` нь класс компонент шаарддаг тул hook хувилбар байхгүй.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    /**
     * Хөгжүүлэлтийн үед стек хаана эвдэрснийг харуулна. Хожим Sentry зэрэг
     * хяналтын систем нэмэх бол мэдээллийг ЭНД дамжуулна.
     */
    console.error('ErrorBoundary caught:', error, info?.componentStack);
  }

  /** Дахин ачаалалгүйгээр сэргэхийг эхлээд туршина */
  handleRetry = () => this.setState({ error: null });

  handleReload = () => window.location.reload();

  render() {
    const { error } = this.state;

    if (!error) return this.props.children;

    return (
      <Result
        status="error"
        title="Алдаа гарлаа"
        subTitle="Хуудсыг харуулах үед гэнэтийн алдаа гарлаа. Дахин оролдоно уу."
        extra={[
          <Button type="primary" key="retry" onClick={this.handleRetry}>
            Дахин оролдох
          </Button>,
          <Button key="reload" onClick={this.handleReload}>
            Хуудсыг сэргээх
          </Button>,
        ]}
        style={{ padding: '48px 16px' }}
      >
        {/* Алдааны мессежийг зөвхөн хөгжүүлэлтийн үед харуулна */}
        {process.env.NODE_ENV === 'development' && (
          <Paragraph>
            <Text code copyable style={{ fontSize: 12 }}>
              {String(error?.message ?? error)}
            </Text>
          </Paragraph>
        )}
      </Result>
    );
  }
}

export default ErrorBoundary;
